export default __webpack_public_path__ + "static/media/wind.c90f3e21.svg";